<template>
  <div
    class="admin-view"
    v-if="hasAdminRole"
  >
    <login @submit="submitLogin" />
  </div>
</template>

<script>
  import Login from '../login/Login'
  import { SIGN_INTO_IDM, GET_ALL_PERMISSIONS } from '@/store/modules/idmAuth/actions'

  export default {
    components: {
      Login,
    },
    computed: {
      hasAdminRole() {
        let r = this.$store.getters.userRoles
        return r && r.hasAdminRole()
      },
      loggedIn() {
        return this.$store.state.idmAuth.loggedIn
      },
    },
    methods: {
      submitLogin(userinfo) {
        this.$store.dispatch(SIGN_INTO_IDM, userinfo).then(resp => {
          if (resp) {
            this.$store.dispatch(GET_ALL_PERMISSIONS)
            this.$router.replace({ name: 'Permissions' })
          }
        })
      },
    },
  }
</script>

<style>
  .admin-view {
    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// AdminLogin.vue?348d4bde